import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { homeFor } from "../../lib/auth";

/** Admin-only subtree. Everyone else — a user admin too (AUTH-13) — goes home. */
export const Route = createFileRoute("/_authed/_admin")({
  beforeLoad: ({ context }) => {
    const role = context.user?.role;
    if (role !== "ADMIN") throw redirect({ to: role ? homeFor(role) : "/login" });
  },
  component: () => <Outlet />,
});
